// Adjust these values to change the printed Salary Statement's appearance -
// no component code needs to change. (SRS Section 17: configurable layout.)
export const reportLayoutConfig = {
  pageMarginCm: 1,
  fontSize: '12px',
  headingFontSize: '18px',
  subheadingFontSize: '14px',
  rowHeight: '22px',
  borderThickness: '1px',
  // How many rows fit on one printed page, for manual pagination (see
  // utils/paginate.js) - employee rows, the TOTAL row, and the Prepared/
  // Verified/Authorised signature row (weighted ~3 rows tall) all count
  // against this same number, not on top of it. Leave null to auto-estimate
  // from the sizes above; set a number here to override the estimate if
  // real printed output doesn't match it exactly for your browser/printer.
  rowsPerPage: 25,
}
